<template>
    <b-container fluid>
        <b-row>
            <b-col v-if="!user.profile.client_side">
                <app-autocomplete
                    :items="clients"
                    v-model="theSupervisionClient"
                    @change="setTheSupervisionClient"
                    label="Seleccione un cliente"
                ></app-autocomplete>
            </b-col>
        </b-row>
        <br />
        <b-form-row>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionToolsRevision')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Estado de herramientas</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionChecklist')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Lista de chequeo</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionNotebook')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Minutas</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionSafetyRecommendation')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Recomendación de seguridad</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionContactReport')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Reporte de contacto</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionSimulation')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Simulacros / Capacitaciones</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionCameraReview')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Formato Revisión de Camaras</b-btn
                >
            </b-col>
            <b-col cols="6">
                <b-btn
                    squared
                    variant="confirm"
                    @click="goTo('supervisionVehicleStateReviews')"
                    style="min-height: 70px;"
                    :disabled="!clientSelected"
                    block
                    >Novedades Vehiculares</b-btn
                >
            </b-col>
        </b-form-row>
    </b-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { SET_SUPERVISION_CLIENT } from '@store/commitTypes'
export default {
    data: () => ({
        theSupervisionClient: '',
    }),
    computed: {
        ...mapGetters(['clients', 'supervisionClient', 'client', 'user']),
        clientSelected() {
            return !!this.supervisionClient
        },
    },
    watch: {
        client: {
            handler(val) {
                if (
                    this.user &&
                    this.user.profile &&
                    !this.user.profile.client_side &&
                    val
                ) {
                    this.setSupervisionClient(val)
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapMutations({
            setSupervisionClient: SET_SUPERVISION_CLIENT,
        }),
        setTheSupervisionClient(client) {
            this.setSupervisionClient(client)
        },
        initialize() {
            if (!this.user || !this.user.profile) return
            if (this.user.profile.client_side && this.client) {
                this.setSupervisionClient(this.client)
            }
            if (this.supervisionClient) {
                this.theSupervisionClient = this.supervisionClient
            }
        },
        goTo(action) {
            this.$router.push({ name: action })
        },
    },
    created() {
        if (this.user && this.user.profile && !this.user.profile.client_side) {
            this.load('clients')
        }
        this.initialize()
    },
}
</script>
